import React from "react";

export const TransferIscon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16675 3.33337L10.8334 10L4.16675 16.6667"
        stroke="#0B0C0E"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16675 3.33337L15.8334 10L9.16675 16.6667"
        stroke="#0B0C0E"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
